export enum ApiLocalRoutesEnum {
  API_URL = 'http://localhost',
  DEV_API_URL = 'https://dev.backendapi.appliedbiox.com/api/',
  API_PORT = ':3000/api/',
  API_SUFFIX_LOGIN = 'customer/login',
  API_SUFFIX_LOGOUT = 'customer/logout',
  API_SUFFIX_ADMIN_REGISTERATION = 'admin-register-api',
  API_SUFFIX_BODY_MEASUREMENTS = 'manage-bodymeasurements-api',
  API_SUFFIX_BODY_MEASUREMENTS_DETAILS = 'manage-bodymeasurements-api/details',
  API_SUFFIX_BODY_MEASUREMENTS_ASSESSMENT = 'manage-bodymeasurements-api/assessment',
  API_SUFFIX_BODY_MEASUREMENTS_TEST_SESSION_PROCESS = 'manage-bodymeasurements-api/test-session/process',
  API_SUFFIX_BODY_MEASUREMENTS_TEST_SESSION_REVIEW = 'manage-bodymeasurements-api/test-session/review-test',
  API_SUFFIX_BODY_MEASUREMENTS_TEST_SESSION_COMPLETE = 'manage-bodymeasurements-api/test-session/complete-test',
  API_SUFFIX_BODY_MEASUREMENTS_COMPLETE = 'manage-bodymeasurements-api/test-session/completed-tests',
  API_SUFFIX_BODY_MEASUREMENTS_COMPLETE_ALL = 'manage-bodymeasurements-api/all',
  API_SUFFIX_BODY_MEASUREMENTS_HISTORY = 'manage-bodymeasurements-api/test-history',

  API_SUFFIX_BODY_MEASUREMENTS_TEST_SESSION_REPORT = 'manage-bodymeasurements-api/test-session/report-test',

  API_SUFFIX_MANAGE_REPORTS_API = 'manage-reports-api',

  API_SUFFIX_BODY_MEASUREMENTS_TEST_SESSION = 'manage-bodymeasurements-api/test-session/active',
  API_SUFFIX_BODY_MEASUREMENTS_CHECK_IN = 'manage-bodymeasurements-api/test-session/check-in',
  API_SUFFIX_BODY_MEASUREMENTS_DETAILS_SOFT = 'manage-bodymeasurements-api/calculate/test-session/soft',
  // #2108 — identity-scoped client-history feed (customer dashboard/account +
  // admin's manage-bodymeasurement.service.ts, via a different composed base).
  API_SUFFIX_BODY_MEASUREMENTS_CLIENT_HISTORY = 'manage-bodymeasurements-api/test-session/client-history',

  API_SUFFIX_OPERATORS = 'manage-operators-api',
  API_SUFFIX_OPERATORS_DETAILS = 'manage-operators-api/details',

  API_SUFFIX_CHECKOUT_TOTAL = 'checkout-api/total',
  API_SUFFIX_STRIPE_CHECKOUT_PAYMENT_INTENT = 'checkout-api/create-payment-intent',

  API_SUFFIX_CLUBS = 'manage-clubs-api',
  API_SUFFIX_CLUBS_DETAILS = 'manage-clubs-api/details',

  API_SUFFIX_CUSTOMERS = 'manage-customers-api',
  API_SUFFIX_CUSTOMERS_DETAILS = 'manage-customers-api/details',

  API_SUFFIX_LICENSE = 'licensing-api',
  API_SUFFIX_LICENSE_VALIDATE = 'licensing-api/validate',
  API_SUFFIX_LICENSE_GENERATE = 'licensing-api/generate',
  // #2108 — bare module prefix (the admin allowedList's module-wildcard entry);
  // API_SUFFIX_PLATFORM_ENTITLEMENT_SELF below is the only concrete sub-route.
  API_SUFFIX_PLATFORM_ENTITLEMENT = 'platform-entitlement',
  API_SUFFIX_PLATFORM_ENTITLEMENT_SELF = 'platform-entitlement/self',

  API_SUFFIX_MEALPLANS = 'manage-mealplans-api',
  API_SUFFIX_MEALPLANS_DETAILS = 'manage-mealplans-api/details',

  API_SUFFIX_PUB_TEST_EVENTS = 'events-api',
  API_SUFFIX_PUB_TEST_EVENTS_DETAILS = 'events-api/public-events/details',
  API_SUFFIX_PUB_TEST_EVENTS_AVAILABILE_SLOTS = 'events-api/public-events/available-slots',
  API_SUFFIX_PUB_TEST_EVENTS_PRODUCTS = 'events-api/public-events/products',
  API_SUFFIX_PUB_TEST_EVENTS_STATES = 'events-api/us-states',

  API_SUFFIX_PUB_TEST_CLUB_DETAILS = 'events-api/details',

  API_SUFFIX_TEST_EVENTS = 'manage-events-api',
  API_SUFFIX_TEST_EVENTS_LIST = 'manage-events-api/event/list',
  // #1148/#1153: tenant-scoped events-list row shape (EventListRowI) the
  // redesigned admin events table renders — carries region, capacity, booked
  // count and PAID revenue per event. Guarded by TenantContextGuard server-side.
  API_SUFFIX_TEST_EVENTS_TENANT_LIST = 'manage-events-api/tenant/list',

  API_SUFFIX_TEST_EVENTS_AVAILABILE_SLOTS = 'manage-events-api/available-slots',
  API_SUFFIX_TEST_EVENTS_RESERVE_SLOTS = 'manage-events-api/reserve-slots',

  API_SUFFIX_TEST_EVENTS_ALL_SLOTS = 'manage-events-api/all-slots',
  API_SUFFIX_TEST_EVENTS_GENERATE_SLOTS = 'manage-events-api/generate-slots',

  API_SUFFIX_TEST_EVENTS_DETAILS = 'manage-events-api/details',
  API_SUFFIX_TEST_EVENTS_CANCEL_EVENT = 'manage-events-api/cancel-event',

  API_SUFFIX_EMAILS = 'manage-emails-api',
  API_SUFFIX_EMAILS_DETAILS = 'manage-emails-api/details',

  API_SUFFIX_DISCOUNTS = 'manage-discounts-api',
  API_SUFFIX_DISCOUNTS_VALIDATE = 'manage-discounts-api/validate',

  API_SUFFIX_DISCOUNTS_DETAILS = 'manage-discounts-api/details',

  API_SUFFIX_SERVICES = 'services-api',
  API_SUFFIX_SERVICES_UPCOMING_EVENT_COUNT_SUFFIX = 'upcoming-event-count',

  // Leading-slash values are appended directly (`${base}${enum}`); others use a separator (`${base}/${enum}`).
  API_SUFFIX_DETAILS = '/details/',

  API_SUFFIX_MIGRATION = 'migration-api',

  API_SUFFIX_BOOKING = 'manage-booking-api',
  API_SUFFIX_BOOKING_SEARCH = 'manage-booking-api/search',

  API_SUFFIX_BOOKING_DETAILS = 'manage-booking-api/details',
  API_SUFFIX_BOOKING_EVENT_LIST = 'manage-booking-api/event/list',
  // Demo-day P0 fix: the admin Booking/Signups History page is keyed by
  // CUSTOMER id (a customer's history across events), not eventId — it must
  // not reuse API_SUFFIX_BOOKING_EVENT_LIST.
  API_SUFFIX_BOOKING_CUSTOMER_HISTORY = 'manage-booking-api/customer',
  // #615 — operator QR check-in scan: POST the scanned signed token, get the
  // booking + customer + event context back (tenant-scoped server-side).
  API_SUFFIX_BOOKING_CHECKIN_SCAN = 'manage-booking-api/check-in/scan',

  API_SUFFIX_PAYMENTS = 'manage-payments-api',
  API_SUFFIX_PAYMENTS_DETAILS = 'manage-payments-api/details',
  API_SUFFIX_STRIPE_CREATE_PAYMENT_INTENT = 'manage-payments-api/create-payment-intent',

  API_SUFFIX_PAYMENTS_BOOKING = 'manage-booking-api/process-booking',
  API_SUFFIX_PROCESS_BOOKING_CREDIT = 'manage-booking-api/process-booking-credit',
  API_SUFFIX_CANCEL_BOOKING = 'manage-booking-api/cancel-booking',
  API_SUFFIX_FINALIZE_BOOKING = 'manage-booking-api/finalize-booking',
  // #1783 — admin/operator create-booking (tenant-scoped, see manage-booking-api.controller.ts).
  API_SUFFIX_BOOKING_ADMIN_CREATE = 'manage-booking-api/admin-create',

  API_SUFFIX_PAYMENTS_BOOKING_RESCHEDULE = 'manage-booking-api/reschedule-booking',

  // #509 — public check-in QR endpoint (PNG). `{api}/manage-notifications/booking/:id/qr`.
  API_SUFFIX_NOTIFICATIONS_BOOKING = 'manage-notifications/booking',

  // API_SUFFIX_BOOKING_DETAILS = 'manage-booking-api/details',

  API_SUFFIX_PROFILE = 'profile',
  API_SUFFIX_PROFILE_USER = 'profile/user/',
  API_SUFFIX_PROFILE_ADDRESS = 'profile/address',
  API_SUFFIX_PROFILE_SECURITY = 'profile/security',
  // #2136: API_SUFFIX_PROFILE_ACCOUNT ('profile/account') and
  // API_SUFFIX_PROFILE_NOTIFICATIONS ('profile/notifications') were removed —
  // no backend controller has ever served those routes, and the profile-ui
  // forms that PATCHed them were deleted with the same issue.
  API_SUFFIX_PROFILE_CUSTOMER = 'customer/profile',

  // Customer self-service account endpoints (#1017 profile, #1019 notification prefs).
  // @IdentityScoped predecessor: JWT-guarded, identity from token (no :id).
  API_SUFFIX_CUSTOMER_SELF_PROFILE = 'customer-self-service-api/profile',
  API_SUFFIX_CUSTOMER_SELF_NOTIFICATIONS = 'customer-self-service-api/notification-preferences',
  // Data-subject rights (#1020, ADR-0014): same @IdentityScoped predecessor pattern.
  API_SUFFIX_CUSTOMER_SELF_EXPORT = 'customer-self-service-api/export',
  API_SUFFIX_CUSTOMER_SELF_DELETE_ACCOUNT = 'customer-self-service-api/delete-account',
  // Customer-portal identity-scoped my-bookings (#1400 / #825). JWT-guarded,
  // customer derived from the token email server-side (no :id/email param), so a
  // signed-in customer sees their OWN bookings without typing an email.
  API_SUFFIX_CUSTOMER_PORTAL_BOOKINGS = 'customer-portal/bookings',
  // #2108 — customer dashboard's "download my latest results" PDF (same
  // identity-scoped customer-portal/* family as the bookings route above).
  API_SUFFIX_CUSTOMER_PORTAL_RESULTS_PDF = 'customer-portal/results/latest/pdf',

  API_SUFFIX_TEST_EVENTS_EVENT = '/events/',
  API_SUFFIX_TEST_EVENTS_ADDRESS = '/events/address',
  API_SUFFIX_TEST_EVENTS_SEARCH = 'manage-events-api/search',

  API_SUFFIX_TEST_EVENTS_SEARCH_GYM = 'manage-events-api/search/gymName',

  API_SUFFIX_SIGNUP_SEARCH = 'manage-signups-api',
  API_SUFFIX_SIGNUP_SETTINGS = 'manage-signups-api/configure',

  API_SUFFIX_SIGNUP_DETAILS = 'manage-signups-api/details',
  API_SUFFIX_SIGNUP_AVAILABILITY = 'manage-signups-api/signup-availability',

  API_SUFFIX_REGISTER = 'registration-api/register',

  API_SUFFIX_USERS = 'manage-users-api',
  API_SUFFIX_USERS_DETAILS = 'manage-users-api/details',

  API_SUFFIX_SETTINGS = 'manage-settings-api',
  API_SUFFIX_SETTINGS_DETAILS = 'manage-settings-api/details',

  API_SUFFIX_ORDERS = 'manage-orders-api',
  API_SUFFIX_ORDERS_DETAILS = 'manage-orders-api/details',
  API_SUFFIX_ORDERS_CONFIRMATION = 'manage-orders-api/confirmation',

  // #2108 — bare module prefix (the admin allowedList's module-wildcard entry);
  // every concrete sub-route below already had its own member.
  API_SUFFIX_PRODUCTS_BASE = 'manage-products-api',
  API_SUFFIX_PRODUCTS_PUBLIC = 'manage-products-api/public/stripe/products',
  API_SUFFIX_PRODUCTS = 'manage-products-api/stripe/products',
  // Intentional alias: product-details requests share the products route base.
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  API_SUFFIX_PRODUCTS_DETAILS = 'manage-products-api/stripe/products',
  API_SUFFIX_PRODUCTS_SERVICES = 'manage-products-api/services',

  API_SUFFIX_REGIONS = 'manage-regions-api',
  API_SUFFIX_REGIONS_DETAILS = 'manage-regions-api/details',

  API_SUFFIX_SMS = 'manage-sms-api',
  API_SUFFIX_SMS_DETAILS = 'manage-sms-api/details',

  API_SUFFIX_TRUCKS = 'manage-trucks-api',
  API_SUFFIX_TRUCKS_STATUS = 'manage-trucks-api/truck-status',

  API_SUFFIX_TRUCKS_DETAILS = 'manage-trucks-api/details',

  API_SUFFIX_TENANT = 'tenant-api',
  API_SUFFIX_TENANT_USER = 'tenant-api/tenant-user',
  // #2108 — onboarding module prefix, distinct from tenant-api above (no
  // concrete sub-route member yet; the admin allowedList only needs the bare
  // module-wildcard entry).
  API_SUFFIX_TENANT_PROVISIONING = 'tenant-provisioning',
  // #2108 — manage-branding-api's tenant-scoped branding controllers
  // (`tenants/:tenantId/branding`, `tenants/by-slug/:slug/branding`); serves
  // ONLY the branding controllers today, nothing else under this prefix.
  API_SUFFIX_TENANTS = 'tenants',

  API_SUFFIX_RESERVATIONS = 'manage-reservations-api',
  // Public (unauthenticated) lead-capture route for the bring-my-truck form.
  API_SUFFIX_RESERVATIONS_PUBLIC = 'manage-reservations-api/public',

  // Admin Overview dashboard (issue #1144 / #1458) — tenant-scoped, read-only.
  API_SUFFIX_ADMIN_DASHBOARD = 'admin-dashboard-api',
  API_SUFFIX_ADMIN_DASHBOARD_OVERVIEW = 'admin-dashboard-api/overview',
  API_SUFFIX_ADMIN_DASHBOARD_WEEKLY_CAPACITY = 'admin-dashboard-api/weekly-capacity',
  API_SUFFIX_ADMIN_DASHBOARD_ACTIVITY = 'admin-dashboard-api/activity',
}
